import { BaSeTheme } from '@base/react';
import styled, { css } from 'styled-components';
import logoSebrae from '../../../assets/logo-sebrae.png';

const handleQuerySmall = (style) => {
  return `
  ${BaSeTheme.breakpoints.tablet.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobileLarge.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobile.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobileSmall.mediaQueryCss(style)};
  `;
};

export const ContainerHeader = styled.div`
  height: 100%;
  width: 100%;
`;

export const HeaderContent = styled.div`
  display: flex;
  justify-content: center;
`;

export const HeaderWrapper = styled.div`
  max-width: ${BaSeTheme.breakpoints.desktop.minWidth}px;
  width: 100%;
  padding-left: 20px;
  display: flex;
  align-items: center;
`;

export const LogoSebrae = styled.div`
  width: 68px;
  height: 36.6px;
  background: url(${logoSebrae}) no-repeat;
`;

export const LogoEmpretec = styled.div`
  width: 120px;
  height: 24px;
  margin-left: 24px;
  ${({ img }) => css`
    background: url(${img}) no-repeat;
  `}
`;

export const HeaderLogoContainer = styled.div`
  display: flex;
  align-items: center;

  justify-content: start;
  ${handleQuerySmall(`
    justify-content: center;
  `)}
  height: 60px;
`;

export const LineHeader = styled.hr`
  padding: 0px;
  margin: 0px;
  border: none;
  height: 1px;
  background: rgba(240, 246, 254, 0.5);
`;
